/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Matrix_MandatoryInputs */

const cs_portals_matrix_mandatory = /** @type {(inputs: Portals_Matrix_MandatoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`povinné`)
};

const en_portals_matrix_mandatory = /** @type {(inputs: Portals_Matrix_MandatoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`required`)
};

/**
* | output |
* | --- |
* | "required" |
*
* @param {Portals_Matrix_MandatoryInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_matrix_mandatory = /** @type {((inputs?: Portals_Matrix_MandatoryInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Matrix_MandatoryInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_matrix_mandatory(inputs)
	return cs_portals_matrix_mandatory(inputs)
});